import { UserManagerSettings } from 'oidc-client-ts';

export const userManagerConfig: UserManagerSettings = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}`,
  client_id: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
  redirect_uri: window.location.origin,
  silent_redirect_uri: `${window.location.origin}/silent-redirect.html`,
  automaticSilentRenew: false,
  silentRequestTimeoutInSeconds: 10,
  revokeTokensOnSignout: true,
};
